<template>
    <div>
    <div class="week-pager">
        <p>
            <v-icon>mdi-arrow-left-bold-box-outline</v-icon>
            <span>2020年8月</span>
            <v-icon>mdi-arrow-right-bold-box-outline</v-icon>
        </p>
    </div>
    <v-card
        class="d-flex justify-space-between mb-6"
        flat
    >
        <v-card
                class="pa-4"
                flat
        >
            <div class="week">月</div>
            <div class="day">24</div>
        </v-card>
        <v-card
                class="pa-4"
                flat
        >
            <div class="week">火</div>
            <div class="day">25</div>
        </v-card>
        <v-card
                class="pa-4"
                flat
        >
            <div class="week">水</div>
            <div class="day">26</div>
        </v-card>
        <v-card
                class="pa-4"
                flat
        >
            <div class="week">木</div>
            <div class="day">27</div>
        </v-card>
        <v-card
                class="pa-4"
                flat
        >
            <div class="week">金</div>
            <div class="day">28</div>
        </v-card>
        <v-card
                class="pa-4"
                flat
        >
            <div class="week light-blue--text ">土</div>
            <div class="day light-blue--text ">29</div>
        </v-card>
        <v-card
                class="pa-4"
                flat
        >
            <div class="week pink--text">日</div>
            <div class="day pink--text">30</div>
        </v-card>

    </v-card>
    </div>
</template>

<script>
    export default {
        name: "WeekCalender"
    }
</script>

<style scoped>
    .week-pager span {
        margin: 8px;
    }

</style>
